import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { useLanguage } from "../../i18n/LanguageContext";

export default function ProjectModal({ project, onClose }) {
  const { t } = useLanguage();
  const open = !!project;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="project-modal"
        className="max-w-4xl w-[95vw] max-h-[92vh] overflow-y-auto md:overflow-hidden bg-[#0a0a0a] border border-white/10 text-[#F5F5F0] p-0 rounded-none"
      >
        {project && (
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="relative h-72 md:h-full min-h-[360px] bg-[#0F0F0F]">
              {project.image ? (
                <img
                  src={project.image}
                  alt={project.title}
                  className={`absolute inset-0 w-full h-full ${
                    project.fit === "contain"
                      ? "object-contain bg-[#f4e6d8]"
                      : "object-cover"
                  }`}
                />
              ) : (
                <div className="absolute inset-0 bg-gradient-to-br from-[#1a1814] via-[#0d0c0a] to-[#050505] flex items-center justify-center">
                  <img
                    src="/logo.png"
                    alt=""
                    aria-hidden
                    className="h-28 w-28 object-contain opacity-30"
                  />
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent md:bg-gradient-to-r md:from-transparent md:via-transparent md:to-[#0a0a0a]/60" />
            </div>

            <div className="p-8 md:p-12 flex flex-col justify-between md:max-h-[80vh] md:overflow-y-auto">
              <div>
                <div className="flex items-center gap-3 mb-5">
                  <span className="h-px w-8 bg-[#C5A059]" />
                  <span className="text-[10px] tracking-[0.32em] uppercase text-[#C5A059]">
                    {project.status}
                  </span>
                </div>
                <DialogTitle
                  data-testid="modal-title"
                  className="font-display text-3xl md:text-4xl leading-tight text-[#F5F5F0]"
                >
                  {project.title}
                </DialogTitle>
                <DialogDescription className="sr-only">
                  {project.title}
                </DialogDescription>
                <div className="mt-3 text-[12px] tracking-[0.22em] uppercase text-[#A3A3A3]">
                  {project.format}
                </div>
                <div className="mt-1 text-[12px] tracking-[0.05em] text-[#9c9b94]">
                  {t.modal.productionPrefix} · {project.production}
                </div>
                {project.genre && (
                  <div
                    className="mt-1 text-[12px] tracking-[0.05em] text-[#9c9b94]"
                    data-testid="modal-genre"
                  >
                    {t.modal.genrePrefix} · {project.genre}
                  </div>
                )}

                <div className="my-7 tcp-divider" />

                <div className="text-[10px] tracking-[0.32em] uppercase text-[#C5A059] mb-3">
                  {t.modal.pitchLabel}
                </div>
                <p
                  data-testid="modal-pitch"
                  className="text-[#D8D7CF] text-[15px] md:text-base leading-[1.75] whitespace-pre-line"
                >
                  {project.pitch}
                </p>
              </div>

              <div className="mt-8 flex flex-wrap items-center gap-4">
                {project.trailer && (
                  <a
                    href={project.trailer}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="trailer-button"
                    className="inline-flex items-center gap-3 border border-[#C5A059] text-[#C5A059] hover:bg-[#C5A059] hover:text-[#050505] transition-all duration-300 px-6 py-3 text-[11px] tracking-[0.3em] uppercase"
                  >
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="currentColor" aria-hidden>
                      <path d="M0 0v14l12-7L0 0z" />
                    </svg>
                    {t.modal.trailer}
                  </a>
                )}
                <button
                  type="button"
                  onClick={onClose}
                  data-testid="modal-close"
                  className="text-[11px] tracking-[0.3em] uppercase text-[#9c9b94] hover:text-[#F5F5F0] transition-colors"
                >
                  {t.modal.close}
                </button>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
